<div class="pt-1">
    <p-messages></p-messages>
</div>

@if (showLoading) {
    <div class="text-center" [ngStyle]="{minHeight: contentMinHeight}">
        <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="4" animationDuration="1.5s"></p-progressSpinner>
        <div class="loading-text my-2">
            {{ loadingStr }}
        </div>
    </div>
} @else {
    <div
        [style.display]="!showLoading ? 'block' : 'none'"
        [ngStyle]="{minHeight: contentMinHeight}"
        class="floatingLabelContainer p-4 overflow-auto"
    >
        <form [formGroup]="form" class="m-1">
            <div severity="info">
                <span>
                    Location <strong>{{ config.data?.location?.name }}</strong> with type
                    <strong>{{ config.data?.location?.type?.toLowerCase() }}</strong> has
                    <strong>{{ totalDescendantsCount }} descendant(s)</strong>, please select one of the following
                    options:
                </span>
            </div>

            <div class="d-flex flex-column">
                <!-- Option 1: CASCADE DELETE -->
                <div class="d-flex align-items-start mt-3" style="gap: 1rem">
                    <p-radiobutton [value]="true" formControlName="isCascade" inputId="mode-cascade"></p-radiobutton>
                    <label for="mode-cascade" class="w-100">
                        <span>Delete this location and all its descendant(s)</span>
                        <p-message severity="warn" styleClass="mt-2">
                            <span>
                                This action is irreversible. All
                                <strong>{{ totalDescendantsCount }} descendant(s)</strong> will be permanently deleted.
                            </span>
                        </p-message>
                    </label>
                </div>

                <!-- Option 2: REASSIGN TO LOCATION -->
                <div
                    class="d-flex align-items mt-3 mb-3"
                    [ngStyle]="{
                        gap: '1rem',
                        cursor: isReassignChildrenAvailable() ? 'auto' : 'not-allowed',
                        'pointer-events': isReassignChildrenAvailable() ? 'auto' : 'none'
                    }"
                >
                    <p-radiobutton
                        [value]="false"
                        formControlName="isCascade"
                        inputId="mode-reassign"
                        [ngStyle]="{opacity: isReassignChildrenAvailable() ? 1 : 0.6}"
                    ></p-radiobutton>
                    <label for="mode-reassign" class="w-100">
                        <span [ngStyle]="{opacity: isReassignChildrenAvailable() ? 1 : 0.6}"
                            >Reassign children to another location</span
                        >
                        @if (isReassignChildrenAvailable()) {
                            <p-floatlabel variant="on" class="mt-2">
                                <p-treeSelect
                                    inputId="targetLocation"
                                    formControlName="targetLocation"
                                    [options]="availableLocationsTree.children"
                                    title="Select a target location for reassignment"
                                    emptyMessage="No compatible locations available"
                                    [filter]="true"
                                    [filterInputAutoFocus]="true"
                                    selectionMode="single"
                                    [showClear]="true"
                                    appendTo="body"
                                    [virtualScroll]="true"
                                    [virtualScrollItemSize]="35"
                                    [virtualScrollOptions]="{scrollHeight: '15rem'}"
                                >
                                    <ng-template pTemplate="default" let-node>
                                        <div style="display: flex; align-items: center; gap: 0.5rem">
                                            <span [class]="LocationUtils.getIconForType(node.type)"></span>
                                            <span>{{ node.label }}</span>
                                            @if (node.key === currentParentUUID) {
                                                <p-tag value="Current parent" severity="info" [rounded]="true"></p-tag>
                                            }
                                        </div>
                                    </ng-template>
                                </p-treeSelect>
                                <label for="targetLocation">Target location</label>
                            </p-floatlabel>
                        } @else {
                            <p-message severity="info" styleClass="mt-2">
                                Not available: no compatible locations available for reassignment.
                            </p-message>
                        }
                    </label>
                </div>
            </div>

            <p-divider />

            <!-- Confirmation field -->
            <div class="mt-2">
                <p>Are you sure that you want to delete directory {{ config.data?.location?.name }}:</p>
                <p-floatlabel variant="on">
                    <input
                        id="confirmationInput"
                        type="text"
                        pInputText
                        class="w-full"
                        formControlName="confirmation"
                    />
                    <label for="confirmationInput">Confirmation</label>
                </p-floatlabel>

                <p class="mt-2">
                    <i class="pi pi-trash mr-1"></i> To confirm deletion, please type the location name:
                    <p-tag severity="primary" [rounded]="true" [value]="config.data?.location?.name"></p-tag>
                </p>
            </div>
        </form>
    </div>

    <div class="p-dialog-footer">
        <p-button severity="contrast" icon="pi pi-times" type="button" label="Cancel" (onClick)="onCancel()" />
        <p-button severity="primary" label="Delete" (onClick)="onSubmit()" [disabled]="!canSubmit()" />
    </div>
}
